export const frontmatter = {
    "title": "What is OnnIA?",
    "description": "OnnIA is the platform that unifies channels, AI agents, and automation to orchestrate operations from end to end.",
    "sidebar_label": "What is OnnIA?",
    "sidebar_group": "concepts",
    "sidebar_order": 1,
    "hide_title": true,
    "toc": false
}

export const toc = [
    {
        "depth": 2,
        "id": "the-three-pillars",
        "value": "The three pillars"
    },
    {
        "depth": 2,
        "id": "the-problem-it-solves",
        "value": "The problem it solves"
    },
    {
        "depth": 2,
        "id": "how-it-works",
        "value": "How it works"
    },
    {
        "depth": 2,
        "id": "who-is-it-for",
        "value": "Who is it for?"
    },
    {
        "depth": 2,
        "id": "ai-in-the-process",
        "value": "AI in the process"
    }
]